module.exports = __webpack_public_path__ + "img/idea-base.d3a42b7b.png";